import { render, staticRenderFns } from "./CampaignStatus.vue?vue&type=template&id=ff74f004&"
import script from "./CampaignStatus.vue?vue&type=script&lang=js&"
export * from "./CampaignStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports